import type { DatasetActionsDeleteProps } from "./dataset-actions-delete.type";

import DatasetDeleteMutatorButton from "@/modules/dataset/dataset-delete-mutator-button";
import { useDatasetsMutatorDatasetTypeStatus } from "@/modules/datasets/datasets-mutator";

export const DatasetActionsDelete = ({
  datasetType,
  dataset,
  loading,
  disabled,
}: DatasetActionsDeleteProps) => {
  const { toBeDeleted, isSaving } =
    useDatasetsMutatorDatasetTypeStatus(datasetType);

  if (!dataset || loading || disabled || isSaving || toBeDeleted) return null;

  return <DatasetDeleteMutatorButton dataset={dataset} />;
};
